import React, { Component } from 'react'
require('./topic.scss')

export default class Topic extends Component {
  render() {
    return (
      <div className="topic">
        <span className="topic-text">{this.topic()}</span>
      </div>
    )
  }

  topic() {
    if (this.props) {
      return this.props.topic || ''
    }

    return ''
  }
}



// WEBPACK FOOTER //
// ./src/views/topic/Topic.jsx